import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { Helpers } from '../../../../app/helpers';
import { EwayBillService } from '../../services/EwayBill/eway-bill.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../../app/_services/app.service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { TranslateConfigService } from '../../../../app/theme/home/translateConfig.service';
const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
  selector: 'app-eway-bill-log',
  templateUrl: './eway-bill-log.component.html',
  styleUrls: ['./eway-bill-log.component.scss']
})
// Added by priya - 28/01/2026 - Eway bill log - cn(PRIYA-JAN26-014)
export class EwayBillLogComponent implements OnInit {

  @Output() onCloseEvent = new EventEmitter<any>();
  static that: EwayBillLogComponent;
  selectedLang: any;
  tableDetails: ITableModel;
  // isMobileView: boolean;
  noOfPages: number = 15;
  viewType: any;
  totalCount: any = 0
  reportHeader: any = [];
  userId: any;
  @Input() ConsignmentDetailId: any;
  @Input() BookingId: any;
  @Input() OrderId: any;

  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private translate: TranslateService,
    private router: Router,
    private service: TranslateConfigService,
    private eway: EwayBillService
  ) { 
    EwayBillLogComponent.that = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.initalizeForm();
    this.GetLogList();
  }

  async initalizeForm() {
    this.tableDetails = {
      emptyDataMSg: "No Records Found",
      data: [],
      columnDetails: [],
      actionList: [],
      isColumnNameShow: true
    };
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails,
      paginationDetails: {
        totalItems: this.totalCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1,
      },
      data: data,
    };
  }

  GetLogList(pageNo: number = 0, perPage: any = this.noOfPages) {
    Helpers.setLoading(true);
    var Start = pageNo * perPage;
    var Length = perPage;
    var SearchValue = null;
    this.eway.GetEwayBillLog(Start, Length, SearchValue, this.userId, this.ConsignmentDetailId, this.BookingId, this.OrderId).then((response: any) => {
      if (response.length) {
        this.totalCount = response[0].Count;

        let i = 0;
        response.forEach(function (value, prop, obj) {
          if (i == 0) {
            delete value["Count"];
            EwayBillLogComponent.that.reportHeader = Object.getOwnPropertyNames(value);
          }
          i++;
        });

        this.tableDetails.columnDetails = [];
        for (const item of this.reportHeader) {
          var obj: any = {};
          obj.columnName = item;
          obj.dataFieldName = item;
          this.tableDetails.columnDetails.push(obj);
        }
      }
      this.assignTableFields(pageNo, perPage, response);
    })
    .catch(err => {
      console.error(err);
    });
  }

  onPageChange(pageNo: number) {
    const storedPerPage = localStorage.getItem('perPage') || this.noOfPages;
    this.GetLogList(pageNo - 1, storedPerPage);
  }

  onPageNumberChange(noOfPages: any) {
    localStorage.setItem('perPage', noOfPages);
    this.noOfPages = noOfPages
    this.GetLogList(0, noOfPages);
  }

  close() {
    this.onCloseEvent.emit();
  }

}
